import { connect } from 'react-redux';

import LearningAdminModuleSerieEditScreen from '../components/LearningAdminModuleSerieEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSerieEditScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSerieEditScreen);

export default LearningAdminModuleSerieEditScreenContainer;
